var confirmModal = null;

window.OnOperationReady = function () {

    $(".btn-option:not(.btn-estimate)").click(function () {
        $('.btn-option[data-posnr=' + $(this).attr('data-posnr') + ']').removeClass("btn-option-enabled");
        $('.btn-option[data-posnr=' + $(this).attr('data-posnr') + ']').addClass("btn-option-disabled");
        $('.btn-option[data-posnr=' + $(this).attr('data-posnr') + ']').attr('data-option-approved', 'false');
        $(this).addClass("btn-option-enabled");
        $(this).addClass("btn-option-enabled").attr('data-option-approved', 'true');

        // Only enable estimate buttons on payment-only pages (no Terms & Conditions workflow)
        // On pages with Terms & Conditions, service buttons are controlled exclusively by the checkbox
        // Do NOT touch #acceptService or #declineService as they are controlled by checkbox only
        if ($('.btn-option:not(.btn-option-disabled):not(.btn-estimate)[data-posnr]').length < 1) {
            // Enable PAY NOW button only if this is a payment-only page (no acceptTerms checkbox)
            if ($('#acceptTerms').length === 0) {
                $('.btn-estimate:not(#acceptService):not(#declineService)').prop('disabled', false);
            }
        }
    });

    // Only enable estimate buttons on payment-only pages (no Terms & Conditions workflow)
    // On pages with Terms & Conditions, service buttons are controlled exclusively by the checkbox
    if ($('.btn-option:not(.btn-option-disabled):not(.btn-estimate)[data-posnr]').length < 1) {
        // Enable PAY NOW button only if this is a payment-only page (no acceptTerms checkbox)
        if ($('#acceptTerms').length === 0) {
            $('.btn-estimate:not(#acceptService):not(#declineService)').prop('disabled', false);
        }
    }

    confirmModal = $('#confirm-modal').appendTo("body").ConfirmModal();

    $('.btn-option').click(function () {
        UpdateTotal();
    });


    if ($('.btn-option:not(.btn-option-disabled):not(.btn-estimate)[data-posnr]').length < 1) {
        // Enable PAY NOW button only if this is a payment-only page (no acceptTerms checkbox)
        if ($('#acceptTerms').length === 0) {
            $('.btn-estimate:not(#acceptService):not(#declineService)').prop('disabled', false);
        }
    }

    let params = (new URL(document.location)).searchParams;
    if (params.has('notificationType'), params.has('notificationMessage')) {
        Notification(params.get('notificationType'), params.get('notificationMessage'))
    }

    // Handle acceptTerms checkbox to enable/disable Pay Now button
    const checkboxElement = document.getElementById('acceptTerms');
    if (checkboxElement) {
        function enableDisablePayNowButton() {
            if (checkboxElement.checked) {
                $('.btn-estimate').prop('disabled', false);
            } else {
                $('.btn-estimate').prop('disabled', true);
            }
        }

        checkboxElement.addEventListener('change', () => {
            enableDisablePayNowButton();
        });

        enableDisablePayNowButton();
    }
}

window.SetRepairApproval = function (approved) {

    var urlConfirm = GenerateYesBinding(approved, hasToPayShippingFees, requireCreditCard);
    var onYesClick;
    var approvalData = GetApprovalData(approved);

    onYesClick = submitApproval(urlConfirm, approvalData);

    if (approvalData.approved === "R" || approvalData.approved === "A"
    ) {
        confirmModal.Open();
    }

    confirmModal.OnYesClick(onYesClick);
};

window.UpdateTotal = function () {


    var total = parseFloat($('.subtotalEstimate > :first(b)').text());
    var currency = parseFloat($('.subtotalEstimate > :nth-child(2)').text());
    $('.btn-option-approve[data-option-approved="true"]').each(function () {
        total += parseFloat($(this).attr("data-option-amount"));
    });

    var nbDecimals = currency == "KWR" ? 0 : 2;

    $('.totalEstimate > :first(b)').text(total.toFixed(nbDecimals));
}

function HandlePSP(approvalData) {
    $('#approved').val(approvalData.approved);
    $('#approvedOptions').val(approvalData.approvedOptions);
    $('#operationsForm').submit();
}

function submitApproval(urlConfirm, approvalData) {
    return function () {
        $.ajax({
            type: "POST",
            url: urlConfirm,
            data: approvalData,
            datatype: 'json',
            success: function (data) {
                confirmModal.Close();
                Notification(data.notificationType, data.notificationMessage);
                $('#operationsContainer').html(data.operationsInfo);
                $('#stepsContainer').html(data.stepsInfo);
            },
            statusCode: {
                401: function () {
                    window.location.href = "/Brand/" + $("#brandCode").val() + "/Account/Login";
                }
            },
            error: function (xhr, status, error) {
                confirmModal.Close();
                Notification("ERROR", "An error occured. Try again later. Sorry for the inconvenience.");
            }
        });
    }
};

window.Notification = function (notificationType, notificationMessage) {

    $('.notification').removeClass('notification-success notification-error notification-warning');

    switch (notificationType) {
        case "SUCCESS":
            $('.notification').addClass('notification-success');
            break;
        case "ERROR":
            $('.notification').addClass('notification-error');
            break;
        default:
            $('.notification').addClass('notification-warning');
    }

    $('.notification-content').html(notificationMessage);
    $('.notification').show();
}

window.GetApprovalData = function (approved) {

    var approvalData = {};

    approvalData.approved = approved;

    var posNr = [];
    $('.btn-option-approve[data-option-approved="true"]').each(function () {
        posNr.push($(this).attr('data-posnr'));
    });
    var approvedOptions = posNr.join(',');

    approvalData.approvedOptions = approvedOptions;

    return approvalData;
}

window.GenerateYesBinding = function (approved, hasToPayShippingFees, requireCreditCard) {

    var urlConfirm = '/Service/Approve';

    if ((requireCreditCard == "True" && approved == "A") || (requireCreditCard == "True" && hasToPayShippingFees == "True" && approved == "R")) {
        urlConfirm = '/CreditCard/Index';
    }

    return urlConfirm;
}


/***********************************************
    Confirm modal
************************************************/

$.fn.ConfirmModal = function () {
    var $element = this;

    return {
        OnYesClick: function (onYesClick) {
            if (onYesClick != undefined) {
                $element.find('.confirm-modal-button-yes').unbind('click');
                $element.find('.confirm-modal-button-yes').click(function () {
                    // Disable all buttons in the modal to prevent multiple clicks
                    $element.find('.confirm-modal-button').prop('disabled', true);

                    // Show the loading overlay by adding the 'show' class
                    $element.find('#confirm-modal-overlay').addClass('show');

                    // Prevent ESC key from closing modal during processing
                    // Initialize if not already initialized
                    if (!$element.data('bs.modal')) {
                        $element.modal({ keyboard: false, backdrop: 'static' });
                    }
                    var modalInstance = $element.data('bs.modal');
                    if (modalInstance && modalInstance.options) {
                        modalInstance.options.keyboard = false;
                    }

                    // Call the original click handler
                    onYesClick();
                });
            }
        },
        Close: function () {
            // Hide the loading overlay by removing the 'show' class
            $element.find('#confirm-modal-overlay').removeClass('show');
            // Re-enable ESC key for future uses
            var modalInstance = $element.data('bs.modal');
            if (modalInstance && modalInstance.options) {
                modalInstance.options.keyboard = true;
            }
            $element.modal('hide');
        },
        Open: function () {
            // Configure modal to disable keyboard and backdrop close
            $element.modal({
                keyboard: false,
                backdrop: 'static'
            });
            $element.modal('show');
        }
    };
}